// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeFollowsSetBody = {
  followedSportIds: string[];
  followedLeagueIds: string[];
};

export type typeFollowsSetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { followedSportIds: string[]; followedLeagueIds: string[] };
};

export type typeFollowsSetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeFollowsSetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeFollowsSetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaFollowsSetBody = {
  type: "object",
  properties: {
    followedSportIds: {
      type: "array",
      items: { type: "string", maxLength: 3000, minLength: 1 },
    },
    followedLeagueIds: {
      type: "array",
      items: { type: "string", maxLength: 3000, minLength: 1 },
    },
  },
  required: ["followedSportIds", "followedLeagueIds"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createFollowsSet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaFollowsSetBody);
  }

  return async function postFollowsSet(
    payload: typeFollowsSetBody,
  ): Promise<typeFollowsSetOutput200 | typeFollowsSetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postFollowsSet" failed before calling the network. #53e2436c3929`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#53e2436c3929" },
        },
        data: null,
      } as typeFollowsSetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/follows/set`,
      httpMethod: "POST",
      options,
    })) as typeFollowsSetOutput200 | typeFollowsSetOutput400;
  };
}
